import {ElMessage} from "element-plus"
import {ElNotification} from "element-plus"
const isProd = import.meta.env.VITE_IS_PROD
const cyrillicPattern = /[\u0400-\u04FF]/
import Auth from "@/services/Auth"

export default {
  async handle(error) {
    if (this.isStatus401(error)) {
      Auth.logout()
    } else {
      let msg = await this.isMessage(error)
      if (msg) {
        this.handleMessage(msg, error)
      } else {
        if (error.code == "ECONNABORTED") {
          this.showMessage("Превышен лимит ожидания!")
        }
      }
    }
  },
  isStatus401(error) {
    return error.response && error.response.status == 401
  },
  async isMessage(error) {
    if (
      error.request.responseType === "blob" &&
      error.response.data instanceof Blob &&
      error.response.data.type &&
      error.response.data.type.toLowerCase().indexOf("json") != -1
    ) {
      error.response.data = await (new Response(error.response.data)).json()
    }
    return error.response && error.response.data && error.response.data.message
  },
  handleMessage(msg, error) {
    if (isProd) {
      if (cyrillicPattern.test(msg)) {
        this.showMessage(msg)
      }
    } else {
      this.showExtendedMessage(error)
    }
  },
  showMessage(msg) {
    ElMessage({
      message: msg,
      type: "error",
      duration: 5000,
      showClose: true,
    })
  },
  showExtendedMessage(error) {
    let res = error.response
    let title = res.status + " " + res.statusText
    let msg = res.request.responseURL + "\n" + res.data.message
    ElNotification({
      title: title,
      message: msg,
      type: "error",
      duration: 5000,
      showClose: true,
    })
  },
}
